import { ScrollLock } from "../../core/scroll-lock";
import { ModalNestedPosition } from "../../util/modal-nested-position";
import { UsersAdminApi, type UsersAdminLoginHistoryResponse } from "../../user/admin/users-admin-api";
import { UsersAdminUtils } from "../../user/admin/users-admin-utils";
import type { LoginHistoryForm } from "./login-history-form";
import type { LoginHistoryRender } from "./login-history-render";

export class LoginHistoryHandler {
    private readonly form: LoginHistoryForm;
    private readonly render: LoginHistoryRender;

    public constructor(form: LoginHistoryForm, render: LoginHistoryRender) {
        this.form = form;
        this.render = render;
    }

    public async open(button: HTMLButtonElement): Promise<void> {
        const modal = this.form.getModal();
        if (!(modal instanceof HTMLElement)) return;

        const userId = Number(button.dataset.userId);
        if (!Number.isInteger(userId) || userId <= 0) return;

        const displayName = button.dataset.userDisplayName?.trim() ?? "";

        this.render.renderTitle(displayName);
        this.render.renderLoading();
        ModalNestedPosition.openModal({ modalEl: modal, displayValue: "block" });
        ScrollLock.lock();

        try {
            const response = await UsersAdminApi.getLoginHistoryByUser(userId);
            const result = (await response.json().catch(() => ({}))) as UsersAdminLoginHistoryResponse;

            if (!response.ok || result.success !== 1) {
                this.render.renderError();
                return;
            }

            this.render.renderList(UsersAdminUtils.toLoginHistoryArray(result.data ?? []));
        } catch {
            this.render.renderError();
        }
    }

    public close(): void {
        const modal = this.form.getModal();
        if (!(modal instanceof HTMLElement)) return;

        ModalNestedPosition.closeModal({ modalEl: modal });
        ScrollLock.unlock();
    }
}
